/**
 * Binance Staking REST API
 *
 * OpenAPI Specification for the Binance Staking REST API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ConfigurationRestAPI,
    TimeUnit,
    RestApiResponse,
    assertParamExists,
    sendRequest,
    type RequestArgs,
} from '@binance/common';
import type {
    GetSoftStakingProductListResponse,
    GetSoftStakingRewardsHistoryResponse,
    SetSoftStakingResponse,
} from '../types';

/**
 * SoftStakingApi - axios parameter creator
 */
const SoftStakingApiAxiosParamCreator = function (configuration: ConfigurationRestAPI) {
    return {
        /**
         * Get the available Soft Staking product list.
         *
         * Weight: 50
         *
         * @summary Get Soft Staking Product List (USER_DATA)
         * @param {string} [asset] WBETH or BETH, default to BETH
         * @param {number | bigint} [current] Currently querying page. Start from 1. Default:1
         * @param {number | bigint} [size] Default:10, Max:100
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getSoftStakingProductList: async (
            asset?: string,
            current?: number | bigint,
            size?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (current !== undefined && current !== null) {
                localVarQueryParameter['current'] = current;
            }
            if (size !== undefined && size !== null) {
                localVarQueryParameter['size'] = size;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/soft-staking/list',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * * The time between `startTime` and `endTime` cannot be longer than 3 months.
         * If `startTime` and `endTime` are both not sent, then the last 30 days' data will be returned.
         * If `startTime` is sent but `endTime` is not sent, the next 30 days' data beginning from `startTime` will be returned.
         * If `endTime` is sent but `startTime` is not sent, the 30 days' data before `endTime` will be returned.
         *
         * Weight: 50
         *
         * @summary Get Soft Staking Rewards History(USER_DATA)
         * @param {string} [asset] WBETH or BETH, default to BETH
         * @param {number | bigint} [startTime]
         * @param {number | bigint} [endTime]
         * @param {number | bigint} [current] Currently querying page. Start from 1. Default:1
         * @param {number | bigint} [size] Default:10, Max:100
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getSoftStakingRewardsHistory: async (
            asset?: string,
            startTime?: number | bigint,
            endTime?: number | bigint,
            current?: number | bigint,
            size?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (current !== undefined && current !== null) {
                localVarQueryParameter['current'] = current;
            }
            if (size !== undefined && size !== null) {
                localVarQueryParameter['size'] = size;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/soft-staking/history/rewardsRecord',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Enable or disable Soft Staking.
         *
         * Weight: 50
         *
         * @summary Set Soft Staking (USER_DATA)
         * @param {boolean} softStaking true or false
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        setSoftStaking: async (
            softStaking: boolean,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'softStaking' is not null or undefined
            assertParamExists('setSoftStaking', 'softStaking', softStaking);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (softStaking !== undefined && softStaking !== null) {
                localVarQueryParameter['softStaking'] = softStaking;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/soft-staking/set',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
    };
};

/**
 * SoftStakingApi - interface
 * @interface SoftStakingApi
 */
export interface SoftStakingApiInterface {
    /**
     * Get the available Soft Staking product list.
     *
     * Weight: 50
     *
     * @summary Get Soft Staking Product List (USER_DATA)
     * @param {GetSoftStakingProductListRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof SoftStakingApiInterface
     */
    getSoftStakingProductList(
        requestParameters?: GetSoftStakingProductListRequest
    ): Promise<RestApiResponse<GetSoftStakingProductListResponse>>;
    /**
     * * The time between `startTime` and `endTime` cannot be longer than 3 months.
     * If `startTime` and `endTime` are both not sent, then the last 30 days' data will be returned.
     * If `startTime` is sent but `endTime` is not sent, the next 30 days' data beginning from `startTime` will be returned.
     * If `endTime` is sent but `startTime` is not sent, the 30 days' data before `endTime` will be returned.
     *
     * Weight: 50
     *
     * @summary Get Soft Staking Rewards History(USER_DATA)
     * @param {GetSoftStakingRewardsHistoryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof SoftStakingApiInterface
     */
    getSoftStakingRewardsHistory(
        requestParameters?: GetSoftStakingRewardsHistoryRequest
    ): Promise<RestApiResponse<GetSoftStakingRewardsHistoryResponse>>;
    /**
     * Enable or disable Soft Staking.
     *
     * Weight: 50
     *
     * @summary Set Soft Staking (USER_DATA)
     * @param {SetSoftStakingRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof SoftStakingApiInterface
     */
    setSoftStaking(
        requestParameters: SetSoftStakingRequest
    ): Promise<RestApiResponse<SetSoftStakingResponse>>;
}

/**
 * Request parameters for getSoftStakingProductList operation in SoftStakingApi.
 * @interface GetSoftStakingProductListRequest
 */
export interface GetSoftStakingProductListRequest {
    /**
     * WBETH or BETH, default to BETH
     * @type {string}
     * @memberof SoftStakingApiGetSoftStakingProductList
     */
    readonly asset?: string;

    /**
     * Currently querying page. Start from 1. Default:1
     * @type {number | bigint}
     * @memberof SoftStakingApiGetSoftStakingProductList
     */
    readonly current?: number | bigint;

    /**
     * Default:10, Max:100
     * @type {number | bigint}
     * @memberof SoftStakingApiGetSoftStakingProductList
     */
    readonly size?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof SoftStakingApiGetSoftStakingProductList
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getSoftStakingRewardsHistory operation in SoftStakingApi.
 * @interface GetSoftStakingRewardsHistoryRequest
 */
export interface GetSoftStakingRewardsHistoryRequest {
    /**
     * WBETH or BETH, default to BETH
     * @type {string}
     * @memberof SoftStakingApiGetSoftStakingRewardsHistory
     */
    readonly asset?: string;

    /**
     *
     * @type {number | bigint}
     * @memberof SoftStakingApiGetSoftStakingRewardsHistory
     */
    readonly startTime?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof SoftStakingApiGetSoftStakingRewardsHistory
     */
    readonly endTime?: number | bigint;

    /**
     * Currently querying page. Start from 1. Default:1
     * @type {number | bigint}
     * @memberof SoftStakingApiGetSoftStakingRewardsHistory
     */
    readonly current?: number | bigint;

    /**
     * Default:10, Max:100
     * @type {number | bigint}
     * @memberof SoftStakingApiGetSoftStakingRewardsHistory
     */
    readonly size?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof SoftStakingApiGetSoftStakingRewardsHistory
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for setSoftStaking operation in SoftStakingApi.
 * @interface SetSoftStakingRequest
 */
export interface SetSoftStakingRequest {
    /**
     * true or false
     * @type {boolean}
     * @memberof SoftStakingApiSetSoftStaking
     */
    readonly softStaking: boolean;

    /**
     *
     * @type {number | bigint}
     * @memberof SoftStakingApiSetSoftStaking
     */
    readonly recvWindow?: number | bigint;
}

/**
 * SoftStakingApi - object-oriented interface
 * @class SoftStakingApi
 */
export class SoftStakingApi implements SoftStakingApiInterface {
    private readonly configuration: ConfigurationRestAPI;
    private localVarAxiosParamCreator;

    constructor(configuration: ConfigurationRestAPI) {
        this.configuration = configuration;
        this.localVarAxiosParamCreator = SoftStakingApiAxiosParamCreator(configuration);
    }

    /**
     * Get the available Soft Staking product list.
     *
     * Weight: 50
     *
     * @summary Get Soft Staking Product List (USER_DATA)
     * @param {GetSoftStakingProductListRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetSoftStakingProductListResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof SoftStakingApi
     * @see {@link https://developers.binance.com/docs/staking/soft-staking/ Binance API Documentation}
     */
    public async getSoftStakingProductList(
        requestParameters: GetSoftStakingProductListRequest = {}
    ): Promise<RestApiResponse<GetSoftStakingProductListResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.getSoftStakingProductList(
            requestParameters?.asset,
            requestParameters?.current,
            requestParameters?.size,
            requestParameters?.recvWindow
        );
        return sendRequest<GetSoftStakingProductListResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * * The time between `startTime` and `endTime` cannot be longer than 3 months.
     * If `startTime` and `endTime` are both not sent, then the last 30 days' data will be returned.
     * If `startTime` is sent but `endTime` is not sent, the next 30 days' data beginning from `startTime` will be returned.
     * If `endTime` is sent but `startTime` is not sent, the 30 days' data before `endTime` will be returned.
     *
     * Weight: 50
     *
     * @summary Get Soft Staking Rewards History(USER_DATA)
     * @param {GetSoftStakingRewardsHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetSoftStakingRewardsHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof SoftStakingApi
     * @see {@link https://developers.binance.com/docs/staking/soft-staking/Get-Soft-Staking-Rewards-History Binance API Documentation}
     */
    public async getSoftStakingRewardsHistory(
        requestParameters: GetSoftStakingRewardsHistoryRequest = {}
    ): Promise<RestApiResponse<GetSoftStakingRewardsHistoryResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.getSoftStakingRewardsHistory(
            requestParameters?.asset,
            requestParameters?.startTime,
            requestParameters?.endTime,
            requestParameters?.current,
            requestParameters?.size,
            requestParameters?.recvWindow
        );
        return sendRequest<GetSoftStakingRewardsHistoryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Enable or disable Soft Staking.
     *
     * Weight: 50
     *
     * @summary Set Soft Staking (USER_DATA)
     * @param {SetSoftStakingRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<SetSoftStakingResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof SoftStakingApi
     * @see {@link https://developers.binance.com/docs/staking/soft-staking/Set-Soft-Staking Binance API Documentation}
     */
    public async setSoftStaking(
        requestParameters: SetSoftStakingRequest
    ): Promise<RestApiResponse<SetSoftStakingResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.setSoftStaking(
            requestParameters?.softStaking,
            requestParameters?.recvWindow
        );
        return sendRequest<SetSoftStakingResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }
}
